module.exports = __webpack_public_path__ + "img/classic_m5.c764c009.png";